import React from "react";

export default class Dropdown extends React.Component {
  state = {
    listVisible: false
  };

  select = item => {
    if (item) {
      const { onSelectItem } = this.props;
      onSelectItem(item);
    }
  };

  show = () => {
    this.setState({ listVisible: true });
    document.addEventListener("click", this.hide);
  };

  hide = () => {
    this.setState({ listVisible: false });
    document.removeEventListener("click", this.hide);
  };

  renderListItems = () => {
    const { list } = this.props;
    return (
      list &&
      list.length &&
      list.map((listItem, index) => {
        return (
          <div
            key={index}
            className="p-15"
            onClick={() => this.select(listItem)}
          >
            <span>{listItem.title || listItem.addressLine1}</span>
          </div>
        );
      })
    );
  };
  render() {
    const { title, routeName } = this.props;

    const { listVisible } = this.state;
    return (
      <div className={"dropdown-container" + (listVisible ? " show" : "")}>
        <div
          className={"dropdown-display" + (listVisible ? " clicked" : "")}
          onClick={this.show}
        >
          <span>{title || routeName}</span>
          <i className="icon icon-arrow-3 open" />
        </div>
        <div className="dropdown-list">
          <div>{this.renderListItems()}</div>
        </div>
      </div>
    );
  }
}
